import { routes } from '~/utils/routes';
import { Link } from '@app/_components/link';
import { css } from '@styled-system/css';

import {
  Box,
  HStack,
  Image,
  Paragraph,
  type HstackProps,
} from '@styled-system/jsx';
import contestIcon from './assets/contest-icon.svg';
import newIcon from './assets/new-icon.svg';
import rankingIcon from './assets/ranking-icon.svg';

type Props = {
  hasNewContest?: boolean;
} & HstackProps;

export const NavigationLinks = ({ hasNewContest, ...hstackProps }: Props) => {
  return (
    <HStack
      width="100%"
      minHeight="56px"
      maxWidth="400px"
      px="12px"
      py="8px"
      justifyContent="space-between"
      gap="0"
      {...hstackProps}
    >
      <Link
        href={routes.genre.ranking.url('horror')}
        className={css({
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          _hover: { opacity: '0.8' },
          _focus: {
            outline: 0,
            outlineColor: 'transparent',
            outlineStyle: 'none',
          },
        })}
      >
        <HStack gap="8px" justifyContent="center">
          <Image src={rankingIcon} alt="ランキング" w="32px" h="32px" />

          <Paragraph color="content_primary" fontSize={14}>
            ランキング
          </Paragraph>
        </HStack>
      </Link>
      <Link
        href={routes.contests.list.url()}
        className={css({
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          _hover: { opacity: '0.8' },
          _focus: {
            outline: 0,
            outlineColor: 'transparent',
            outlineStyle: 'none',
          },
        })}
      >
        <HStack gap="8px" justifyContent="center">
          <Box position="relative">
            <Image src={contestIcon} alt="コンテスト" w="32px" h="32px" />
            {hasNewContest && (
              <Box
                position="absolute"
                top="1px"
                right="0"
                backgroundColor="red"
                borderRadius="full"
                width="8px"
                height="8px"
              />
            )}
          </Box>

          <Paragraph color="content_primary" fontSize={14}>
            コンテスト
          </Paragraph>
        </HStack>
      </Link>
      <Link
        href={routes.stories.url()}
        className={css({
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          _hover: { opacity: '0.8' },
          _focus: {
            outline: 0,
            outlineColor: 'transparent',
            outlineStyle: 'none',
          },
        })}
      >
        <HStack gap="8px" justifyContent="center">
          <Image src={newIcon} alt="新着" w="32px" h="32px" />

          <Paragraph color="content_primary" fontSize={14}>
            新着
          </Paragraph>
        </HStack>
      </Link>
    </HStack>
  );
};
